import groq from 'groq';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

export const blockTitleFields = groq`
title[] {${portableTextWithReferences}},
preTitle[] {${portableTextWithReferences}},
description[] {${portableTextWithReferences}}
`;
